import { ReactNode, useEffect } from 'react';
// next
import { useRouter } from 'next/router';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_GLOBAL } from '../routes/paths';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
};

export default function GuestGuard({ children }: Props) {
  const { push } = useRouter();

  const { isAuthenticated, isAdmin, organization } = useAuth();

  useEffect(() => {
    if (isAuthenticated && isAdmin === false) {
      window.location.href = '/app/' + organization + '/me';
    }
    if (isAdmin) {
      push(PATH_GLOBAL.organizations.root);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, isAdmin]);

  return <>{children}</>;
}
